import { Link } from "react-router-dom";
import { Youtube, MapPin, Mail } from "lucide-react";
import { NAV, SITE, DIRECTIONS_URL, ADDRESS_LINE } from "../content/site";
import { Logo } from "./Nav";
import { MaskLines } from "./motion";

export function Footer() {
  return (
    <footer className="relative overflow-hidden border-t border-[#F6F2F0]/10 bg-[#090909]" data-testid="site-footer">
      <div className="mx-auto max-w-[1440px] px-5 pb-10 pt-20 sm:px-8 lg:px-12 lg:pt-28">
        <MaskLines
          as="p"
          lines={[
            { text: "Fear God.", className: "text-[#F6F2F0]" },
            { text: "Love God.", className: "outline-text" },
            { text: "Obey God.", className: "text-[#B8324E]" },
          ]}
          className="font-display text-[15vw] font-bold uppercase leading-[0.86] tracking-tight sm:text-[11vw] lg:text-[9.5rem]"
          testId="footer-motto"
        />
        <div className="mt-16 grid gap-12 border-t border-[#F6F2F0]/10 pt-12 md:grid-cols-12">
          <div className="md:col-span-4">
            <Logo testId="footer-logo-link" />
            <p className="mt-6 max-w-xs text-sm leading-relaxed text-[#B9AFB2]">
              A non-denominational Christian assembly in Youngstown, Ohio.
            </p>
          </div>
          <div className="md:col-span-3">
            <p className="eyebrow mb-5">Gather</p>
            <p className="font-display text-2xl uppercase text-[#F6F2F0]">{SITE.sunday.day} · {SITE.sunday.time}</p>
            <a href={DIRECTIONS_URL} target="_blank" rel="noopener noreferrer" className="link-sweep mt-3 inline-flex items-start gap-2 text-sm text-[#B9AFB2] hover:text-[#F6F2F0]" data-testid="footer-directions-link">
              <MapPin className="mt-0.5 h-4 w-4 shrink-0" aria-hidden="true" /> {ADDRESS_LINE}
            </a>
          </div>
          <div className="md:col-span-3">
            <p className="eyebrow mb-5">Explore</p>
            <ul className="grid grid-cols-2 gap-x-6 gap-y-3 text-sm">
              {NAV.map((n) => (
                <li key={n.to}>
                  <Link to={n.to} className="link-sweep text-[#B9AFB2] hover:text-[#F6F2F0]" data-testid={`footer-link-${n.label.toLowerCase().replace(/\s+/g, "-")}`}>
                    {n.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
          <div className="md:col-span-2">
            <p className="eyebrow mb-5">Connect</p>
            <a href={SITE.youtube} target="_blank" rel="noopener noreferrer" className="inline-flex min-h-[44px] items-center gap-2 text-sm text-[#F6F2F0] hover:text-[#B8324E]" data-testid="footer-youtube-link">
              <Youtube className="h-5 w-5" aria-hidden="true" /> @GNPCHURCH7
            </a>
            {SITE.email && (
              <a href={`mailto:${SITE.email}`} className="flex min-h-[44px] items-center gap-2 break-all text-sm text-[#F6F2F0] hover:text-[#B8324E]" data-testid="footer-email-link">
                <Mail className="h-5 w-5 shrink-0" aria-hidden="true" /> {SITE.email}
              </a>
            )}
          </div>
        </div>
        <div className="mt-16 flex flex-col gap-3 border-t border-[#F6F2F0]/10 pt-6 text-xs text-[#B9AFB2] sm:flex-row sm:justify-between">
          <p>© {new Date().getFullYear()} GNP Church — God's Name Proclaimed. Youngstown, Ohio.</p>
          <p>To glorify Jesus Christ and call the lost home.</p>
        </div>
      </div>
    </footer>
  );
}
